// extracted by mini-css-extract-plugin
module.exports = {"Convert__currencies":"ConvertedCurrency__Convert__currencies__ae3vb","currencies__header":"ConvertedCurrency__currencies__header__RN7-f"};